import React, {useContext, useState} from 'react';
import {AppContext} from '../contexts/AppContext';
import DatesTab from './BookingBoxOverlay/DatesTab';
import OccupancyTab from './BookingBoxOverlay/OccupancyTab';
const BookingBoxOverlay = () => {

    const {selectedFilters, handleSubmitSearch} = useContext(AppContext);
    const [activeTab, setActiveTab] = useState('dates');
    const [selectedDates, setSelectedDates] = useState([
        selectedFilters.checkin ? new Date(selectedFilters.checkin) : undefined,
        selectedFilters.checkout ? new Date(selectedFilters.checkout) : undefined
    ]);

    const handleNextTab = () => {
        setActiveTab('occupancy');
    };

    const handleBackToDatesTab = () => {
        setActiveTab('dates');
    };

    const handleDateChange = (dates) => {
        if (dates.length === 2) {
            setSelectedDates([...dates]);
        } else {
            setSelectedDates([]);
        }
    };

    const handleSubmit = (rooms) => {
        handleSubmitSearch(selectedDates, rooms);
        setTimeout(() => setActiveTab('dates'), 1000);
    };

    const handleClearDates = () => {
        handleSubmitSearch([], []);
    };

    return (
        <div className="booking-box--overlay--inner page--overlay--inner">
            {activeTab === 'dates' && (
                <DatesTab
                    onChange={handleDateChange}
                    onNext={handleNextTab}
                    onClear={handleClearDates}
                    selectedDates={selectedDates}
                />
            )}
            {activeTab === 'occupancy' && (
                <OccupancyTab
                    onBack={handleBackToDatesTab}
                    onSubmit={handleSubmit}
                    selectedDates={selectedDates}
                />
            )}
        </div>
    );
};

export default BookingBoxOverlay;
